/**** DON'T COMMIT ME!!!****/
export default {
  adminHost: "2-1-0--doc-rdv-manager.netlify.app",
  //  apiId: "cjb0wt3ip369k0192zrue7b5j <-CIPRIANI"
  apiId: "cjfib9fnm65mb0103iyj1qgwz",
  apiSimple:"https://cipriani.digitalmacchiato.com/simple/v1/ck1apxpea000401916vifrsxw",
  apiWS:"wss://cipriani.digitalmacchiato.com/subscriptions/v1/ck1apxpea000401916vifrsxw"

};
/**** DON'T COMMIT ME!!!****/



// WEBPACK FOOTER //
// ./src/config.js